import {
  BuildingFilledIcon,
  MoreHorizontalIcon,
  PeopleFilledIcon,
} from '@adsk/alloy-react-icon';

import AccordionExpandIcon from './AccordionExpandIcon';
import AvatarIcon from './AvatarIcon';
import BreadcrumbsPileIcon from './BreadcrumbsPileIcon';
import NotificationCloseIcon from './NotificationCloseIcon';
import NotificationErrorIcon from './NotificationErrorIcon';
import NotificationInfoIcon from './NotificationInfoIcon';
import NotificationSuccessIcon from './NotificationSuccessIcon';
import NotificationWarningIcon from './NotificationWarningIcon';
import WeaveProgressRing from './WeaveProgressRing';
import { ComponentIcons } from '../types';

/**
 * Component icons for Weave theme.
 *
 * Structure mirrors weave-theme.json component tokens.
 * Each component can have multiple icons for different purposes.
 *
 * @example Future structure based on weave-theme.json:
 * ```ts
 * export const weaveComponentIcons = {
 *   avatar: {
 *     defaultIcon: ProfileM,
 *   },
 *   dropdown: {
 *     caretIcon: CaretDownIcon,    // tokens: dropdown.icon.name = "CaretDownSUI"
 *   },
 *   menu: {
 *     caretIcon: CaretRightIcon,   // tokens: menu.caret.icon.name = "CaretRightSUI"
 *     checkmarkIcon: CheckmarkIcon, // tokens: menu.checkmark.icon.name = "CheckmarkXSUI"
 *   },
 *   notification: {
 *     errorIcon: ErrorIcon,         // tokens: notification.error.icon
 *     infoIcon: InfoIcon,           // tokens: notification.info.icon
 *     successIcon: SuccessIcon,     // tokens: notification.success.icon
 *     warningIcon: WarningIcon,     // tokens: notification.warning.icon
 *   },
 * } as const;
 * ```
 *
 * If you want to use Weave icon from their library, wrap it to properly handle sizing mechanism which differ
 * across alloy (`size`) and weave/mui (`fontSize`):
 *
 * `{ icon: IconWrapper(ProfileM) }`
 *
 * This will also smooth out the props shape
 */
export const weaveComponentIcons: ComponentIcons = {
  accordion: {
    expandIcon: AccordionExpandIcon,
  },
  avatar: {
    defaultIcon: AvatarIcon,
    companyIcon: BuildingFilledIcon,
    roleIcon: PeopleFilledIcon,
  },
  progressRing: WeaveProgressRing,
  breadcrumbs: {
    pileIcon: BreadcrumbsPileIcon,
    pileIconHighDensity: MoreHorizontalIcon,
  },
  notification: {
    closeIcon: NotificationCloseIcon,
    infoIcon: NotificationInfoIcon,
    successIcon: NotificationSuccessIcon,
    warningIcon: NotificationWarningIcon,
    errorIcon: NotificationErrorIcon,
  },
};
